// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4247":"0e6a9787","9119":"0e6a9787"}[chunkId] + ".chunk.css";
};